import React from "react";
import { Alert, Button, Form, Result, Select, Spin } from "antd";
import { useLanguage } from "src/providers/LanguageProvider";
import { useNavigate } from "react-router";

type Option = { value: string | number; label: React.ReactNode };
type Props = {
  value?: string | number | null;
  options?: Option[];
  loading?: boolean;
  error?: string | null;
  onChange?: (v: string | number | null) => void;
};

const BuyLicenseInvoiceProfileSelect: React.FC<Props> = ({
  value,
  options = [],
  loading,
  error,
  onChange,
}) => {
  const { t } = useLanguage();

  const navigate = useNavigate();


  if(options.length === 0){
    return(
          <Result
      status="info"
      title={t("NO_INVOICE_PROFILES")}
      subTitle={t("NO_INVOICE_PROFILES_DESC")}
      extra={
        <Button type="primary" onClick={() => navigate("/invoice-profiles")}>
          {t("CREATE_INVOICE_PROFILE")}
        </Button>
      }
    />


    )
  }



  return (
    <>
      {error && (
        <Alert
          type="error"
          message={error}
          showIcon
          style={{ marginBottom: 8 }}
        />
      )}
      
      <Form layout="vertical" requiredMark={false}>
        <Form.Item label={t("LABEL_INVOICE_PROFILE")}>
          <Select
            value={value as any}
            showSearch
            allowClear
            placeholder={loading ? t("LOADING") : t("PLACEHOLDER_SELECT_INVOICE_PROFILE")}
            loading={!!loading}
            onChange={onChange as any}
            notFoundContent={loading ? <Spin size="small" /> : t("NO_RECORDS")}
            options={options}
            optionFilterProp="label"
            aria-label={t("LABEL_INVOICE_PROFILE")}
          />
        </Form.Item>
      </Form>
    </>
  );
};

export default BuyLicenseInvoiceProfileSelect;
